import { render, staticRenderFns } from "./RicercaMovimenti.vue?vue&type=template&id=59d1caf7&"
import script from "./RicercaMovimenti.vue?vue&type=script&lang=js&"
export * from "./RicercaMovimenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports